import React from "react";
import {
  Box,
  useTheme,
  Divider,
  Zoom,
  Fab,
  useMediaQuery,
  Typography,
  Button,
} from "@mui/material";
import Navbar from "scenes/navbar";
import EmptyDialog from "components/emptyDialog";
import Flexbetween from "components/FlexBetween";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import recapitulatif_premium from "assets/recapitulatif_premium.mp4";
import pack_starter from "assets/pack-starter.jpg";
import pack_starter_pro from "assets/pack-starter-pro.jpg";
import { useEffect } from "react";
import { useState } from "react";
import { useMemo } from "react";

export function getPackFromPriceId(priceId) {
  if (priceId === "price_1QxroyCwieQsrEUZL6mZjXs2") {
    return "premium";
  } else if (priceId === "price_1QxrqlCwieQsrEUZZA4kEXy1") {
    return "starter_pro";
  } else if (priceId === "price_1Qxrs9CwieQsrEUZBp8YBBpy") {
    return "starter";
  }
  return "starter";
}
const CheckoutSuccess = () => {
  const theme = useTheme();
  const largeScreen = useMediaQuery("(min-width: 800px)");
  const ref = useSelector((state) => state.ref);
  const datas = useSelector((state) => state.datas);
  const urlPriceId = new URLSearchParams(window.location.search).get("priceId");
  const [selectedPack, setSelectedPack] = useState(null);

  useEffect(() => {
    setSelectedPack(getPackFromPriceId(urlPriceId));
  }, [urlPriceId]);

  const downloadReport = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/users/report/download?ref=${ref}`
      );
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));

      const link = document.createElement("a");
      link.href = url;
      link.download = `statut-constitutif-${datas["societeName"]}.docx`;

      document.body.appendChild(link);

      link.click();

      link.parentNode.removeChild(link);
      toast.success("Téléchargement du rapport en cours...");
    } catch (error) {
      console.error(error.message);
      toast.error(error.message);
    }
  };

  const downloadProcuration = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/users/procuration/download?ref=${ref}`
      );
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));

      const link = document.createElement("a");
      link.href = url;
      link.download = `procuration-${datas["societeName"]}.docx`;

      document.body.appendChild(link);

      link.click();

      link.parentNode.removeChild(link);
      toast.success("Téléchargement de la procuration en cours...");
    } catch (error) {
      console.error(error.message);
      toast.error(error.message);
    }
  };

  const videoCard = () => {
    if (largeScreen) {
      return (
        <Box
          sx={{
            borderRadius: "16px",
            aspectRatio: "0.8",
            height: "80%",
            maxHeight: "400px",
            overflow: "hidden",
            position: "sticky",
            top: "220px",
          }}
        >
          {selectedPack === "premium" && (
            <video
              style={{ objectFit: "cover", objectPosition: "center" }}
              width="100%"
              height="100%"
              controls
              src={recapitulatif_premium}
            />
          )}
          {selectedPack === "starter_pro" && (
            <img
              src={pack_starter_pro}
              alt="Pack Starter Pro"
              style={{ objectFit: "cover", width: "100%", height: "100%" }}
            />
          )}
          {selectedPack === "starter" && (
            <img
              src={pack_starter}
              alt="Pack Starter"
              style={{ objectFit: "cover", width: "100%", height: "100%" }}
            />
          )}
        </Box>
      );
    } else if (selectedPack === "premium") {
      return (
        <Box sx={{ position: "fixed", bottom: 10, right: 5, opacity: 0.6 }}>
          <EmptyDialog
            content={
              <Box
                sx={{
                  borderRadius: "16px",
                  aspectRatio: "0.8",
                  height: "80%",
                  maxHeight: "400px",
                  overflow: "hidden",
                }}
              >
                <video
                  style={{ objectFit: "cover", objectPosition: "center" }}
                  width="100%"
                  height="100%"
                  controls
                  src={recapitulatif_premium}
                ></video>
              </Box>
            }
          >
            <Zoom
              key="inherit"
              in={true}
              timeout={100}
              style={{
                transitionDelay: "100ms",
              }}
              unmountOnExit
            >
              <Fab
                sx={{
                  color: "common.white",
                  bgcolor: theme.palette.primary.main,
                  "&:hover": {
                    bgcolor: theme.palette.primary.dark,
                  },
                }}
                aria-label="Expand"
                color="inherit"
              >
                Video
              </Fab>
            </Zoom>
          </EmptyDialog>
        </Box>
      );
    }
  };

  const validation_description = useMemo(() => {
    if (selectedPack === "premium") {
      return "Nous avons bien reçu vos informations et vous recevrez prochainement un email de confirmation de votre commande avec les documents à télécharger dont vous aurez besoin pour immatriculer votre société auprès du Guichet Unique.";
    } else if (selectedPack === "starter_pro") {
      return (
        <span>
          Nous avons bien reçu vos informations et vous recevrez prochainement
          un email de confirmation de votre commande avec les documents à
          télécharger dont vous aurez besoin pour immatriculer votre société
          auprès du Guichet Unique.
          <br />
          <br />
          Le mail de confirmation de votre commande comportera un lien pour
          prendre votre rendez-vous de consultation téléphonique avec un avocat
          du Cabinet afin de vérifier et contrôler votre dossier.
        </span>
      );
    } else if (selectedPack === "starter") {
      return "Nous avons bien reçu vos informations et vous recevrez prochainement un email deconfirmation de votre commande avec les documents à télécharger dont vous aurez besoin pour immatriculer votre société auprès du Guichet Unique.";
    }
    return "";
  }, [selectedPack]);

  const validation_description2 = useMemo(() => {
    if (selectedPack !== "premium") {
      return null;
    }
    return (
      <Box
        sx={{
          border: "1px solid #A3A3A3",
          borderRadius: "5px",
          p: "10px",
        }}
      >
        <Typography variant="h5" fontWeight="700">
          Que se passe-t-il ensuite ?
        </Typography>
        <ul style={{ lineHeight: "45px" }}>
          <li style={{ color: theme.palette.neutral.main }}>
            <Typography sx={{ color: theme.palette.neutral.main }}>
              <span style={{ fontWeight: 700 }}>
                Contrôle de vos informations :{" "}
              </span>
              Nous nous assurons que toutes les données fournies sont complètes
              et conformes.
            </Typography>
          </li>
          <li style={{ color: theme.palette.neutral.main }}>
            <Typography sx={{ color: theme.palette.neutral.main }}>
              <span style={{ fontWeight: 700 }}>
                Préparation des documents juridiques à vous faire signer :{" "}
              </span>{" "}
              Nos experts vous adressent pour signature électronique vos
              statuts, formulaires, et autres documents nécessaires.
            </Typography>
          </li>
          <li style={{ color: theme.palette.neutral.main }}>
            <Typography sx={{ color: theme.palette.neutral.main }}>
              <span style={{ fontWeight: 700 }}>
                Dépôt auprès du Guichet unique :{" "}
              </span>{" "}
              Nous envoyons votre dossier pour immatriculer votre société.
            </Typography>
          </li>
          <li style={{ color: theme.palette.neutral.main }}>
            <Typography sx={{ color: theme.palette.neutral.main }}>
              <span style={{ fontWeight: 700 }}>
                Réception de l’extrait K-bis :{" "}
              </span>{" "}
              Une fois votre société immatriculée, vous recevrez votre extrait
              K-bis par email.
            </Typography>
          </li>
        </ul>
      </Box>
    );
  }, [selectedPack, theme.palette.neutral.main]);

  return (
    <Box sx={{ height: "100%", overflowY: "scroll" }}>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          backgroundColor: "#FFF",
          zIndex: 999,
        }}
      >
        <Navbar />
      </Box>
      <Divider />
      <Flexbetween
        sx={{
          justifyContent: "center",
          gap: "4rem",
          alignItems: "flex-start",
          minHeight: "calc(100% - 120px)",
        }}
      >
        {videoCard()}
        <Box
          sx={{
            width: largeScreen ? "40%" : "100%",
            padding: "20px",
            mt: "50px",
          }}
        >
          <Flexbetween
            sx={{ flexDirection: "column", alignItems: "flex-start", gap: 4 }}
          >
            <Typography variant="h2" fontWeight="600">
              Félicitations, votre dossier est enregistré !
            </Typography>
            <Typography>{validation_description}</Typography>
            {validation_description2}
            <Typography variant="h6" fontWeight="600">
              Si vous avez des questions, notre équipe est là pour vous aider.
              <br />
              N'hésitez pas à nous contacter par email à{" "}
              <a href="mailto:contact@alceeavocats.com">
                contact@alceeavocats.com
              </a>{" "}
              ou sur notre WhatsApp professionnel au{" "}
              <a href="https://wa.me/33559619700">0559619700</a>.
            </Typography>
            <Flexbetween gap={"20px"} flexWrap={"wrap"}>
              <Button variant="contained" onClick={() => downloadReport()}>
                Télécharger le rapport
              </Button>
              {selectedPack === "premium" && (
                <Button
                  variant="contained"
                  onClick={() => downloadProcuration()}
                >
                  Télécharger la procuration
                </Button>
              )}
              <Button
                onClick={() =>
                  (window.location.href = "https://www.alceeavocats.com/")
                }
              >
                Revenir sur le site Alcee avocats
              </Button>
            </Flexbetween>
          </Flexbetween>
        </Box>
      </Flexbetween>
    </Box>
  );
};

export default CheckoutSuccess;
